/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEstimateByMonthDto } from './GetEstimateByMonthDto';
import {
    GetEstimateByMonthDtoFromJSON,
    GetEstimateByMonthDtoFromJSONTyped,
    GetEstimateByMonthDtoToJSON,
} from './GetEstimateByMonthDto';

/**
 * 
 * @export
 * @interface GetAttachmentEstimateByMonthDto
 */
export interface GetAttachmentEstimateByMonthDto {
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentEstimateByMonthDto
     */
    id: string;
    /**
     * 
     * @type {GetAttachmentEstimateByMonthDto}
     * @memberof GetAttachmentEstimateByMonthDto
     */
    attachment: GetAttachmentEstimateByMonthDto;
    /**
     * 
     * @type {GetEstimateByMonthDto}
     * @memberof GetAttachmentEstimateByMonthDto
     */
    estimateByMonth: GetEstimateByMonthDto;
}

/**
 * Check if a given object implements the GetAttachmentEstimateByMonthDto interface.
 */
export function instanceOfGetAttachmentEstimateByMonthDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "attachment" in value;
    isInstance = isInstance && "estimateByMonth" in value;

    return isInstance;
}

export function GetAttachmentEstimateByMonthDtoFromJSON(json: any): GetAttachmentEstimateByMonthDto {
    return GetAttachmentEstimateByMonthDtoFromJSONTyped(json, false);
}

export function GetAttachmentEstimateByMonthDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttachmentEstimateByMonthDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'attachment': GetAttachmentEstimateByMonthDtoFromJSON(json['attachment']),
        'estimateByMonth': GetEstimateByMonthDtoFromJSON(json['estimateByMonth']),
    };
}

export function GetAttachmentEstimateByMonthDtoToJSON(value?: GetAttachmentEstimateByMonthDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'attachment': GetAttachmentEstimateByMonthDtoToJSON(value.attachment),
        'estimateByMonth': GetEstimateByMonthDtoToJSON(value.estimateByMonth),
    };
}

